import { ProductCard } from './ProductCard.jsx';

export function ProductGrid({ currency, locale, from, query, products, sellers, sellerColors, style, onProductClick, filteredStoreIds, categoriesPosition, disableFeaturedBorder, logActivity }) {
  if (products.length === 0) {
    return (
      <div className="text-center py-20">
        <p style={{ color: 'var(--color-text-muted)' }}>No hay productos disponibles en esta categoría</p>
      </div>
    );
  }

  return (
    <div style={{flex: 1, height: '100%', overflowX: 'hidden', paddingBottom: 150}}>
      <div className={`a11y-product-grid grid grid-cols-1 sm:grid-cols-3 md:grid-cols-3 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 gap-7 max-w-screen-xl mx-auto ${from === 'search' ? 'px-8' : (categoriesPosition === 'top' ? 'px-8' : 'px-4')} pb-12 pt-10`}>
        {products.map((product) => (
          <ProductCard
            key={product.id}
            currency={currency}
            locale={locale}
            query={query}
            from={from}
            product={product}
            sellers={sellers}
            sellerColors={sellerColors}
            onProductClick={onProductClick}
            style={style}
            filteredStoreIds={filteredStoreIds}
            disableFeaturedBorder={disableFeaturedBorder}
            logActivity={logActivity}
          />
        ))}
      </div>
    </div>
  );
}
